const colors = {
    DEFAULT_PRIMARY_COLOR: '#0099ff',
    DEFAULT_SECONDARY_COLOR: '#f2f2f2',

    DEFAULT_PRIMARY_FONT_COLOR: '#ffffff',
    DEFAULT_SECONDARY_FONT_COLOR: '#3e3e3e',
}

export { colors }
